

export const GET_ALL_CAMAGINS_REQUEST = "GET_ALL_CAMAGINS_REQUEST"
export const GET_ALL_CAMAGINS_SUCCESS = "GET_ALL_CAMAGINS_SUCCESS"
export const GET_ALL_CAMAGINS_FAILED = "GET_ALL_CAMAGINS_FAILED"


export const ADD_NEW_CAMPAGIN_REQUEST = "ADD_NEW_CAMPAGIN_REQUEST"
export const ADD_NEW_CAMPAGIN_SUCCESS = "ADD_NEW_CAMPAGIN_SUCCESS"
export const ADD_NEW_CAMPAGIN_FAILED = "ADD_NEW_CAMPAGIN_FAILED"

export const DELETE_CAMPAGIN_REQUEST = "DELETE_CAMPAGIN_REQUEST"
export const DELETE_CAMPAGIN_SUCCESS = "DELETE_CAMPAGIN_SUCCESS"
export const DELETE_CAMPAGIN_FAILED = "DELETE_CAMPAGIN_FAILED"

export const PAUSE_CAMPAIGN_REQUEST = "PAUSE_CAMPAGIN_REQUEST"
export const PAUSE_CAMPAIGN_SUCCESS = "PAUSE_CAMPAGIN_SUCCESS"
export const PAUSE_CAMPAIGN_FAILED = "PAUSE_CAMPAGIN_FAILED"

export const RESUME_CAMPAIGN_REQUEST = "RESUME_CAMPAIGN_REQUEST"
export const RESUME_CAMPAIGN_SUCCESS = "RESUME_CAMPAIGN_SUCCESS"
export const RESUME_CAMPAIGN_FAILED = "RESUME_CAMPAIGN_FAILED"

export const SORT_BY_DATE = "SORT_BY_DATE"

export const CLEAR_CALL = "CLEAR_CALL"

export const GET_MULITPLE_CJSCID_LIST_REQUEST = "GET_MULITPLE_CJSCID_LIST_REQUEST" 
export const GET_MULITPLE_CJSCID_LIST_SUCCESS = "GET_MULITPLE_CJSCID_LIST_SUCCESS" 
export const GET_MULITPLE_CJSCID_LIST_FAILED = "GET_MULITPLE_CJSCID_LIST_FAILED" 

export const CJSC_EXPORT_TO_CSV_REQUEST = 'CJSC_EXPORT_TO_CSV_REQUEST';
export const CJSC_EXPORT_TO_CSV_SUCCESS = 'CJSC_EXPORT_TO_CSV_SUCCESS';
export const CJSC_EXPORT_TO_CSV_FAILED = 'CJSC_EXPORT_TO_CSV_FAILED';

export const UPDATE_CAMPAIGN_REQUEST = "UPDATE_CAMPAIGN_REQUEST"
export const UPDATE_CAMPAIGN_SUCCESS = "UPDATE_CAMPAIGN_SUCCESS"
export const UPDATE_CAMPAIGN_FAILED = "UPDATE_CAMPAIGN_FAILED"

export const getAllCampaigns = (data:any,showAll:any) => {
    return { type: GET_ALL_CAMAGINS_REQUEST,payload:{data,showAll} }
}
export const addNewCampagin = (data: any,otherpayload:any,callbackFun:any)=>{
    return{type:ADD_NEW_CAMPAGIN_REQUEST,payload:{data,otherpayload},callbackFun:callbackFun}
}
export const deleteCampagin = (data: any) => {
    return { type: DELETE_CAMPAGIN_REQUEST, payload: { value: data } }
}

export const pauseCampaign = (data: any) => {
    return { type: PAUSE_CAMPAIGN_REQUEST, payload: { value: data } }
}
export const updateCampaign = (data: any) => {
    return { type: UPDATE_CAMPAIGN_REQUEST, payload: { data } }
}

export const resumeCampaign = (data: any) => {
    return { type: RESUME_CAMPAIGN_REQUEST, payload: { value: data } }
}

export const sortCampagins = () => {
    return { type: SORT_BY_DATE }
}

export const clearCall = () => {
    return { type: CLEAR_CALL }
}

export const getCJSCIdDropdownList = () => {
    return { type: GET_MULITPLE_CJSCID_LIST_REQUEST }
}

export const exportToCsv = (data:any,showAll:any) => {
    return { type: CJSC_EXPORT_TO_CSV_REQUEST,payload:{data,showAll} }
}